module.exports = __webpack_public_path__ + "static/img/9.21f53a14.png";